import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { RootState } from '../store/rootReducer';

let displayed: number[] = [];

const storeDisplayed = (id: number) => {
  displayed = [...displayed, id];
};

const Notifier: FC = () => {
  const dispatch = useDispatch();
  const { notifications } = useSelector(
    (state: RootState) => state.notification,
  );
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    notifications.forEach(({ message, options, key }) => {
      if (displayed.includes(key)) return;
      enqueueSnackbar(message, options);
      storeDisplayed(key);
    });
  }, [notifications, enqueueSnackbar, dispatch]);

  return null;
};

export default Notifier;
